export default "__VITE_ASSET__97e95ac9__"